export { getBuildInfo, type BuildInfo } from './getBuildInfo';
